import React, { useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TextNumber from "../based/inputs/TextNumber";
import Textbox from "../based/inputs/Textbox";
import TFUImage from "../based/inputs/Image";
import FinanceServices from "../based/services/FinanceServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

function TransferManualModal({ show, onClose, walletId, onSave }) {
    const [model, setModel] = useState({ transferAmount: "", transferDescription: "", transferReferenceCode: "", transferImage: "" });

    const updateTicket = async (model) => {
        const [err, data] = await FinanceServices.UpdateTicketManual({ ...model, walletId: +walletId });
        if (!err && data) {
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra, vui lòng thử lại sau.");
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} hideOnClose title="Chuyển thủ công" size="md" hiddenFooter>
            <Wrapper>
                <div className="form-group">
                    <label htmlFor="" className="required">
                        Nhập số tiền đã chuyển
                    </label>
                    <TextNumber value={model.transferAmount} name="transferAmount" onChanged={(name, value) => setModel({ ...model, transferAmount: value })} />
                </div>
                <div className="form-group">
                    <label htmlFor="Mã giao dịch" className="required">
                        Mã giao dịch ngân hàng
                    </label>
                    <Textbox value={model.transferReferenceCode} name="transferReferenceCode" onChanged={(name, value) => setModel({ ...model, transferReferenceCode: value })} />
                </div>
                <div className="form-group">
                    <label htmlFor="Mô tả" className="required">
                        Ảnh chuyển khoản
                    </label>
                    <TFUImage
                        id="transfer-image"
                        name="transfer-image"
                        value={model.transferImage}
                        onChanged={(name, value) => {
                            setModel({ ...model, transferImage: value });
                        }}
                    />
                </div>
                <div className="lst-action">
                    <button
                        className="btn btn-danger"
                        onClick={(e) => {
                            onClose();
                        }}
                    >
                        Đóng
                    </button>
                    <button className="btn btn-custom" onClick={() => updateTicket(model)}>
                        Xác nhận chuyển
                    </button>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default TransferManualModal;

const Wrapper = styled.div`
    .lst-action {
        display: flex;
        justify-content: center;
    }

    .lst-action .btn {
        margin: 0 6px;
    }
`;
